var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.tableData),function(row,rowIndex){return _c('tr',{key:rowIndex},[_c('th',[_vm._v(_vm._s(row.title))]),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(row.value)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }